import { createVNode as n, mergeProps as a } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InvisibleOutlinedStandard.js";
import d from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return n(d, a(i, {
    icon: o
  }), null);
};
t.displayName = "InvisibleOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
